import capcourseActions from "./actions";

const initialState = {

  getAllcapcourse:[],
  getScoredetails:[],
  capCandidateDetails:[],
  capCandidateAddressDetails:[],
  capCandidateReservationDetails:[],
  capCandidateAcademicDetails:[],
  capCandidateUploadDetails:[],
  capCandidateDocuments : [],
  getAllcapcoursecandidature:[],
  getAllcapcoursecategory:[],
  getCapRegisterDetails : [],
  getCapcourseDistricts : [],
  getCapcourseVcenterByDistrict : [],
  getDateByVcenter : [],
  getSlotVerifyers : [],
  getSlots:[],
  getBookedSlotDetails:[],
  getcapcoursefees:[]



 };

const capcourseReducer = (state = initialState, action) => {
  switch (action.type) {
    

    case capcourseActions.SET_ALL_CAPCOURSE:
        return {
          ...state,
          getAllcapcourse: action.payload,
        };
    case capcourseActions.SET_CAP_CATEGORY:
        return {
          ...state,
          getAllcapcoursecategory: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATURE:
        return {
          ...state,
          getAllcapcoursecandidature: action.payload,
        };

    case capcourseActions.SET_SCOREDETAILS:
        return {
          ...state,
          getScoredetails: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATEDETAILS:
        return {
          ...state,
          capCandidateDetails: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATEADDRESSDETAILS:
        return {
          ...state,
          capCandidateAddressDetails: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATEACADAMICDETAILS:
        return {
          ...state,
          capCandidateAcademicDetails: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATERESERVATIONDETAILS:
        return {
          ...state,
          capCandidateReservationDetails: action.payload,
        };
    case capcourseActions.SET_CAP_CANDIDATEUPLOADDETAILS:
        return {
          ...state,
          capCandidateUploadDetails: action.payload,
        };
    
        case capcourseActions.SET_CAP_CANDIDATE_DOCUMENTS:
        return {
          ...state,
          capCandidateDocuments : action.payload,
        };

        case capcourseActions.SET_CANDIDATE_CAP_REG_DETAILS:
          return {
            ...state,
            getCapRegisterDetails : action.payload,
          };

          case capcourseActions.SET_CAPCOURSE_DISTRICTS:
            return {
              ...state,
              getCapcourseDistricts : action.payload,
            };

            case capcourseActions.SET_CAPCOURSE_VERIFICATION_CENTER:
            return {
              ...state,
              getCapcourseVcenterByDistrict : action.payload,
            };

            case capcourseActions.SET_DATE_BY_VCENTER:
            return {
              ...state,
              getDateByVcenter : action.payload,
            };

            case capcourseActions.SET_SLOT_VERIFYERS:
              return {
                ...state,
                getSlotVerifyers : action.payload,
              };

            case capcourseActions.SET_SLOTS_DETAILS:
              return {
                ...state,
                getSlots : action.payload,
              };
    
            case capcourseActions.SET_BOOKED_SLOT_DETAILS:
              return {
                ...state,
                getBookedSlotDetails : action.payload,
              };
    
            case capcourseActions.SET_CAP_COURSE_AMOUNT:
              return {
                ...state,
                getcapcoursefees : action.payload,
              };
    
  
  
    default:
      return state;
  }
};

export default capcourseReducer;
